/**
 * Returns number with specified number of decimal places
 * @param value input number
 * @param decimalPlaces output decimal places
 * @returns number with specified decimal places
 */
export function toNDecimals(value: number, decimalPlaces: number = 2): number {
    const pwr = 1 * (10 ^ decimalPlaces);
    return Math.round(value * pwr) / pwr;
}